import ArticleItemReturnReason from "@/components/article-item/article-item-return-reason";
import {
  ReturnRequestDto,
  ShopDto,
} from "@babackapp/private-api-client/types";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
interface ReturnHasHilightedReasonProps {
  shop: ShopDto;
  returnRequest: ReturnRequestDto;
}

export default function ReturnHasHilightedReasonProps({
  shop,
  returnRequest,
}: ReturnHasHilightedReasonProps) {
  const reasonsId = returnRequest.line_items
    .filter((li) => li.reasonId)
    .map((li) => li.reasonId);
  const reasonHilighted = reasonsId.find(
    (reasonId) =>
      shop.reasons.find((reason) => reason.id === reasonId)?.rules.highlighted
        .available,
  );
  if (!reasonHilighted) {
    return null;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex p-1">
          <ExclamationTriangleIcon className="size-4 text-red-600" />
        </div>
      </TooltipTrigger>
      <TooltipContent className="bg-white rounded-md shadow-lg p-2">
        <p className="text-sm text-muted-foreground">
          <ArticleItemReturnReason returnReasonId={reasonHilighted} />
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
